import { yupResolver } from '@hookform/resolvers/yup'
import { useForm, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { CustomerFeeFormData, customerFeeSetupSchema } from '../schemas/customerFeeSetupSchema'

export const useCustomerFeeSetupForm = () => {
  const { t } = useTranslation()
  // Relook at from logic when we get to customer fees
  const formSchema = customerFeeSetupSchema(t)

  const form = useForm<CustomerFeeFormData>({
    resolver: yupResolver(formSchema),
  })

  const { control, formState, clearErrors, resetField, setValue, register, trigger, setError } =
    form

  const formValues = useWatch({ control }) as CustomerFeeFormData

  return {
    formValues,
    formState,
    errors: formState.errors,
    clearErrors,
    resetField,
    setValue,
    register,
    setError,
    trigger,
    form,
  }
}
